import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CopyToClipboard extends Component {
  static propTypes = {
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    iconColor: PropTypes.string
  };

  static defaultProps = {
    width: 22,
    height: undefined,
    iconColor: '#000'
  };

  render() {
    const { height, width, iconColor } = this.props;

    return (
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={width} height={height}>
        <path
          fill={iconColor}
          d="M24.12,8.1V28.76H3.46V8.1H24.12m.68-3H2.78C1.5,5.1,.46,6.14,.46,7.42V29.44c0,1.28,1.04,2.32,2.32,2.32H24.8c1.28,0,2.32-1.04,2.32-2.32V7.42c0-1.28-1.04-2.32-2.32-2.32h0Z"
        />
        <path
          fill={iconColor}
          d="M30.3,27.96c-.83,0-1.5-.67-1.5-1.5V3.87H9.24c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5H29.33c.33-.02,.97,.02,1.55,.52,.61,.52,.92,1.3,.92,2.34V26.46c0,.83-.67,1.5-1.5,1.5Z"
        />
      </svg>
    );
  }
}